import { useEffect, useState } from 'react';

const useOutsideClick = (parentRef) => {
    const [clickedOutside, setClickedOutside] = useState(false);

    useEffect(() => {
        const onBodyClick = (e) => {
            const clickedOutsideParentRef = !parentRef?.current?.contains(
                e.target
            );
            setClickedOutside(clickedOutsideParentRef);
        };

        document.body.addEventListener('click', onBodyClick);

        return () => {
            setClickedOutside(false);
            document.body.removeEventListener('click', onBodyClick);
        };
    }, [parentRef]);

    return { clickedOutside };
};

export default useOutsideClick;
